import api from 'ApiConfig';

// Admins hit the admin-guarded mount (/admin/pd-session); teacher and HR keep
// using /pd-session. The layout prefix in the URL tells us which one we're on.
const base = () =>
  /^\/(admin|superadmin)/.test(window.location.pathname) ? '/admin/pd-session' : '/pd-session';

const pdSessionService = {
  createSession: (payload) => api.post(`${base()}/create`, payload),
  getSessions: (params) => api.get(base(), { params }),
  getSessionById: (id) => api.get(`${base()}/detail`, { params: { id } }),
  updateSession: (payload) => api.put(`${base()}/update`, payload),
  markAttendance: (id, date, presentStudents, absentStudents = []) =>
    api.post(`${base()}/attendance`, {
      id,
      date,
      presentStudents,
      absentStudents,
    }),
  listAssignees: () => api.get(`${base()}/assignees`),
  assignSession: (id, assignedTo) =>
    api.put(`${base()}/assign`, { id, assignedTo }),
  deleteSession: (id, hard = false) =>
    api.delete(`${base()}/delete`, { params: { id, hard } }),
  searchStudents: (searchTerm, branches) =>
    api.post(`${base()}/search-students`, { searchTerm, branches }),
  listCourses: (branch) => api.get(`${base()}/courses`, { params: { branch } }),
  listBatchStructures: (courseId) =>
    api.get(`${base()}/batch-structures`, { params: { courseId } }),
  listBatches: (courseId, batchStructureId, branch) =>
    api.get(`${base()}/batches`, {
      params: { courseId, batchStructureId, branch },
    }),
  getBatchStudents: (batchId) =>
    api.post(`${base()}/batch-students`, { batchId }),
};

export default pdSessionService;
